import CreateShopPaymentRequestModelBase from '../_generated/modelBases/create-shop-payment-request-model-base';

export default class CreateShopPaymentRequestModel extends CreateShopPaymentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
